var map = {
	"./EUflag": 341,
	"./EUflag.svg": 341,
	"./Ic_close": 342,
	"./Ic_close.svg": 342,
	"./amphibians": 343,
	"./amphibians.jpeg": 343,
	"./arrow_down": 344,
	"./arrow_down.svg": 344,
	"./butterfly": 141,
	"./butterfly.jpeg": 599,
	"./butterfly.png": 141,
	"./calendar": 345,
	"./calendar.png": 345,
	"./coral": 346,
	"./coral.jpeg": 346,
	"./eggs": 347,
	"./eggs.png": 347,
	"./frog": 348,
	"./frog.png": 348,
	"./iguana": 349,
	"./iguana.png": 349,
	"./lizard": 350,
	"./lizard.png": 350,
	"./logo_dark": 351,
	"./logo_dark.svg": 351,
	"./mammal": 352,
	"./mammal.jpeg": 352,
	"./paisage_autumn": 353,
	"./paisage_autumn.png": 353,
	"./parrot": 354,
	"./parrot.jpeg": 354,
	"./snek": 355,
	"./snek.png": 355,
	"./snek2": 356,
	"./snek2.jpeg": 356,
	"./turtle_head": 357,
	"./turtle_head.png": 357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 598;